const genderSwitch = (id: any) => {
   if (id === "0") return "Masculino";
   if (id === "1") return "Femenino";
   return "Desconocido";
};

export default genderSwitch;
